export default __webpack_public_path__ + "static/01-ranking-shanghai-academic-ranking-of-world-universities-2021-mobile-2cb335b0d7a79025f9d4221a9e508205.svg";